/*
 * @Author: gongzhizhen
 * @Date: 2019-07-26 19:41:27
 * @LastEditTime: 2019-09-24 11:26:50
 * @LastEditors: gongzhizhen
 */
/**
 * commonState.js
 *
 * 各个分支中的公用部分
 * @Author: jruif
 * @Date: 2018/3/13 上午11:03
 */
import { connectRouter } from 'connected-react-router';
import { actionType as type } from 'ReduxModules/action';
import { reducerCreator } from '../util/redux-tool';

export default history => ({
  router: connectRouter(history),
  common: reducerCreator(
    {
      // 可参考'./common.js'帮助理解
      user: {
        wemediaId: null,
        hasFunction: false, // 功能
        shortInfoFlag: false, //短咨询
        askBarFlag: false, //问吧权限
        liveRoomFlag: false, //直播权限
        authorityFlag: false, //帐号特权权限
        shareIncome: false, //我的收益权限
        fetchFlag: false, //抓取权限
        pushFlag: false, //push 权限
        repostFlag: false, //文章转载权限
        comment: false, //跟帖展示
        mcnFlag: false, //mcn
        newAskBarFlag: false, //新问吧
        hotEventFlag: false, //热点事件
        poiFlag: false, //读者兴趣精选
        piyaoFlag: false, // 辟谣权限
        certificationFlag: false, //加V认证
        auditState: -99, // 默认值：请求出错的时候用来显示
        todayPubCount: 0,
        maxDailyPublishCount: 0,
        videoTodayPubCount: 0,
        videoMaxDailyPublishCount: 0,
        //ownerType(主体类型): 0-公司/企业，1-个人，2-党政机关/事业单位，3-媒体，4-其他组织
        //accountType(账号类型): 0-媒体 1-自媒体 2-组织机构 3-直播号 4-企业
        //local(运营权限归属部门): 0-内容运营中心，1-本地事业部，2-政务中心，3-直播中心，5-销售部
      },
    },
    [type.updateCommon],
  ),
  // 消息中心：main、mcn、mobile
  message: reducerCreator(
    {
      list: [],
      unRead: [],
      total: 0,
    },
    [type.updateMsg],
  ),
  statistics: reducerCreator(
    {
      // 数据统计
      overview: {}, // 总览
    },
    [type.updateStatistics],
  ),
  // 消息中心：main、mcn
  notice: reducerCreator(
    {
      list: [], // 平台公告列表
      total: 0, // 平台公告列表总数
      banner: [],
      activity: {
        // 活动
        total: 0,
        list: [],
      },
      topList: {
        // 左侧榜单
        total: 0,
        list: [],
      },
    },
    [type.updateNotice],
  ),
  // 手机号图形验证码
  phoneCaptchaCode: reducerCreator(
    {
      captchaCode: '',
    },
    [type.updatePhoneCaptchaCode],
  ),
});
